/*Hydrates state post-auth & routes user to correct next step */

import type { Partner, PartnerConfig } from '@/configs/partner';
import {
  accountAdded,
  emailAdded,
  resetAccount,
} from '@/lib/account/accountSlice';
import { resetEligibility } from '@/lib/eligibility/eligibilitySlice';
import { resetOrder } from '@/lib/order/orderSlice';
import { cleared as resetRedeem } from '@/lib/redeem/redeemSlice';

import accountHasContent from './accountHasContent';
import { fetchSessionData } from './fetchSessionData';

export const handleNewSession = async (
  email: string,
  partner: Partner,
  partnerConfig: PartnerConfig,
  dispatch: (action: any) => void,
  push: (path: string) => void,
) => {
  dispatch(resetAccount());
  dispatch(resetOrder());
  dispatch(resetEligibility());
  dispatch(resetRedeem());
  const response = await fetchSessionData(email, partner, partnerConfig);

  if (response.error) {
    push(partnerConfig.invalidStep);
  }

  if (response.data) {
    dispatch(emailAdded(email));

    if (accountHasContent(response.data.account)) {
      dispatch(accountAdded(response.data.account!));
    }
    push(partnerConfig.accountStep);
  }
};
